import { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { RegistrationContext } from '../../context/registration';
import { useToasts } from 'react-toast-notifications';

import { setCampaignCommunity } from '~/services/registration';

import { ProgressBar } from './ProgressBar';
import { contactPreferenceCopy } from '~/shared/config';
import {
  Container,
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Form,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';

import { SelectOption } from '~/types/globals';
import { fetchCommunityTypes } from '~/services/options';
import { Loading } from '../../shared/components/Loading';

const communityOptions = [
  {
    label: 'Yes, I do',
    value: 'yes',
  },
  {
    label: "No, I don't",
    value: 'no',
  },
];

export const Community = ({}: any) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [saving, setSaving] = useState<boolean>(false);
  const [{ campaignRequest }, registrationDispatch] =
    useContext(RegistrationContext);
  const [communityTypeOptions, setCommunityTypeOptions] = useState<
    SelectOption[]
  >([]);
  const [selectedCommunityOptions, setSelectedCommunityOptions] = useState<
    string[]
  >([]);
  const [hasCommunity, setHasCommunity] = useState<boolean>();
  const { addToast } = useToasts();
  const history = useHistory();

  const getCommunityTypes = async () => {
    const resp = await fetchCommunityTypes();
    console.log('resp: ', resp);
    const opts = resp.map((opt, i) => {
      return {
        label: opt.name,
        value: opt.code,
      };
    });
    setCommunityTypeOptions(opts);
    setLoading(false);
  };

  useEffect(() => {
    getCommunityTypes();
  }, []);

  const handleNext = async () => {
    try {
      setSaving(true);
      const resp = await setCampaignCommunity(selectedCommunityOptions);
      console.log('selectedCommunityOptions: ', selectedCommunityOptions);
      console.log('resp: ', resp);

      registrationDispatch({
        type: 'set_campaign_request',
        campaignRequest: resp,
      });

      console.log('hasCommunity: ', hasCommunity);

      if (hasCommunity === 'no') {
        history.push('/get-started/contact-preference', {
          copy: contactPreferenceCopy.community,
        });
      } else {
        history.push('/get-started/terms-of-service');
      }
    } catch (e) {
      setSaving(false);
      console.log('e: ', e);
    }
  };

  if (loading) {
    return <Loading />;
  }

  const handleSelectCommunityOption = (code) => {
    let newSelected = selectedCommunityOptions;
    if (selectedCommunityOptions.includes(code)) {
      newSelected = newSelected.filter((x) => x !== code);
    } else {
      newSelected = [...newSelected, code];
    }
    setSelectedCommunityOptions(newSelected);
  };

  console.log('selectedCommunityOptions: ', selectedCommunityOptions);

  const HasCommunityOptions = () => {
    return (
      <FormGroup check className='mb-3'>
        {communityTypeOptions.map((opt, i) => {
          return (
            <div key={i}>
              <Label check>
                <Input
                  type='checkbox'
                  name={opt.value}
                  onChange={() => handleSelectCommunityOption(opt.value)}
                  checked={selectedCommunityOptions.includes(opt.value)}
                />
                {opt.label}
              </Label>
            </div>
          );
        })}
      </FormGroup>
    );
  };

  return (
    <Container>
      <ProgressBar selectedStep='community' />

      <Form>
        <Row className='justify-content-center py-5'>
          <Col md='6'>
            <div className='text-center'>
              <h3>Do you have a community that you can ask for help?</h3>
              <p>
                Fundraising is most successful when it is backed by community
                support, such as your family, friends, and neighbors.
              </p>
            </div>

            <Card
              className='box-shadow my-5'
              style={{
                maxWidth: '400px',
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            >
              <CardBody>
                <FormGroup check className='mb-3'>
                  {communityOptions.map((opt, i) => {
                    return (
                      <div key={i}>
                        <Label check>
                          <Input
                            type='radio'
                            value={opt.value}
                            onClick={() => setHasCommunity(opt.value)}
                            name='has_community'
                          />
                          {opt.label}
                        </Label>
                        {hasCommunity === 'yes' && opt.value === 'yes' ? (
                          <HasCommunityOptions />
                        ) : (
                          ''
                        )}
                      </div>
                    );
                  })}
                </FormGroup>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <div className='text-center mb-5'>
          <Button
            color='outline-dark'
            disabled={saving}
            onClick={() => history.push('/get-started/financials/insurance')}
          >
            Back
          </Button>
          <Button
            color='primary'
            onClick={handleNext}
            // type='submit'
            disabled={saving}
          >
            {saving ? `Saving...` : `Next`}
          </Button>
        </div>
      </Form>
    </Container>
  );
};
